import { Component } from '@angular/core';

@Component({
  selector: 'bff-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'bff-customer';
}
